import { installChunkRecovery } from './utils/chunkRecovery';

// Ловим чанки, пропавшие после деплоя, до того как упадёт рендер.
installChunkRecovery();

// /tg/* is the support team's Telegram Mini App: another application in the
// same bundle, with its own root, router and API client and none of the
// site's session. Decided here, before anything mounts, so App (whose boot
// asks for account_info and sends anyone without a session to /login, which
// a WebView cannot use) and the semantic CSS never load there. A chunk that
// fails to load ends up in installChunkRecovery's unhandledrejection handler.
if (window.location.pathname.startsWith('/tg/')) {
  import('./bootstrap/miniapp');
} else if (window.location.pathname.startsWith('/__preview/')) {
  // TEMPORARY — local UI preview with fixtures (src/__preview__); remove.
  import('./__preview__/transcript');
} else {
  import('./bootstrap/app');
}
